// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"92":"concierge","443":"about"}[chunkId] + "-legacy." + {"92":"987a321f","443":"8965ff1d"}[chunkId] + ".js";
};